import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router'

function RedirectTo() {
  const history = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const redirectTo = searchParams.get('redirect_to')
    if (redirectTo) {
      history(redirectTo)
    }
  })
}

export default RedirectTo
